import { FolderVersion } from '@app/core/model/folder-version.model'

export interface FolderExportModalConfig {
  title: string
  body?: string
  folder?: FolderVersion
  limitModalWidth?: boolean
}

export enum ExcelOutputType {
  EXCEL = 'EXCEL',
  DEPARTMENT_HOURS = 'DEPARTMENT_HOURS',
}
